// Appearance.jsx
import { Row, Col, Form, Button } from "react-bootstrap";

export default function Appearance() {
  return (
    <>
      <h5 className="mb-3">Appearance</h5>

      <div className="section-border">
        <h6>Theme Settings</h6>

        <Row>
          <Col md={6}>
            <Form.Group>
              <Form.Label>Theme Color</Form.Label>
              <Form.Control type="color" />
            </Form.Group>
          </Col>

          <Col md={6}>
            <Form.Group>
              <Form.Label>Font Size</Form.Label>
              <Form.Select>
                <option>Small</option>
                <option>Medium</option>
                <option>Large</option>
              </Form.Select>
            </Form.Group>
          </Col>
        </Row>
      </div>

      <div className="text-end">
        <Button variant="light">Cancel</Button>
        <Button className="btn-orange ms-2">Save</Button>
      </div>
    </>
  );
}